import React,{useState} from 'react'
import {AiOutlineClose,AiOutlineMenu} from 'react-icons/ai';
import {Link} from 'react-router-dom';
const Navbar = () => {
  const[nav,setNav] = useState(false);
  const handleMenu=()=>{
    setNav(!nav)
  }
  return (
    <div className=" justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white flex">
        <h1 className="w-full text-3xl font-bold text-[#E5038B]">Portfolio</h1>
<ul className='hidden md:flex'>
   <a href="#"><li className="p-4">Home</li></a>
    
<a href="#Projects"><li className="p-4">Projects</li></a>
   
</ul>
<div onClick={handleMenu} className="block-md:hidden">
  {!nav ? <AiOutlineMenu size={20}/> : <AiOutlineClose size={20}/>}

</div>

  <ul className={nav ?'fixed left-0 top-0 w-[50%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out':'fixed left-[-100%]'}>
    
  <a href ="#"><li className="p-4 border-b border-gray-500">Home</li></a>
   
  <a href="#Projects"><li className="p-4">Projects</li></a>
   

  </ul>
</div>
  )
}

export default Navbar